export enum SoftwareTypesEnum {
    TAX = 'tax',
    ONLINE = 'online',
}
export const SoftwareTypes = Object.values(SoftwareTypesEnum) as any;


export enum CourseTypesEnum {
    ACCOUNTING = 'Accounting/Bookkeeping',
    ENTREPRENEURSHIP = 'Entrepreneurship',
    BUSINESS = 'Business',
    TAX = 'Tax',
    QUICKBOOKS = 'QuickBooks',
    OTHER = 'Other',
}

export enum ProductCodeEnum {
    QUICKBOOKS_ONLINE = '297-667',
}

export enum ProductCodeEnumCA {
    QUICKBOOKS_TAX_CA = '390-788',
}

export enum AccessLinksEnum {
    QUICKBOOKS_TAX_ACCESS_LINK = 'https://taxeducation.intuit.com/login/#/signin?utm_source=intuiteducation&utm_medium=registration',
    QUICKBOOKS_TAX_ACCESS_LINK_CA = 'https://profile.intuit.ca/download/',
    QUICKBOOKS_TAX_ACCESS_LINK_FR = 'https://profilefrancais.intuit.ca/',
}
